import Vue from 'vue'
import Vuex from 'vuex'
import User from './modules/user'
import Dialog from './modules/dialog'
import Menu from './modules/menu'
import Shade from './modules/shade'
import Collapse from './modules/collapse'
import Operator from './modules/operator'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    User,
    Dialog,
    Menu,
    Shade,
    Collapse,
    Operator
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js